// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/4bd5b0e8/" + chunkId + "." + __webpack_require__.h() + ".v4bd5b0e8.js";
};